// extracted by mini-css-extract-plugin
export default {"container":"Card_container__8ulxr","brand":"Card_brand__0e2XQ"};